import { action, payload } from 'ts-action'
import { IApplication } from '@network/models/application.model'
import { IError, IPayload } from '@network/models/global.model'
import { IGroupApplication } from '@network/models/group-application.model'

export const HiddenApplicationsFetching = action(
  'HiddenApplicationsFetching',
  payload<boolean>(),
)

export const GetHiddenApplications = action(
  'GetHiddenApplications',
  payload<IPayload<IApplication[]>>(),
)

export const UnhideHiddenApplication = action(
  'UnhideHiddenApplication',
  payload<IPayload<IApplication>>(),
)

export const UnhideGroupHiddenApplication = action(
  'UnhideGroupHiddenApplication',
  payload<IPayload<IGroupApplication>>(),
)

export const GetHiddenApplicationsErrors = action(
  'GetHiddenApplicationsErrors',
  payload<IError>(),
)
